module.exports = __webpack_public_path__ + "static/img/文字.74bf58a.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/poster/文字.png
// module id = GWox
// module chunks = 1